
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kWs4M", function(module, exports) {
$parcel$export(module.exports, "CardsExtension", () => (parcelRequire("gnpMO")).CardsExtension);
$parcel$export(module.exports, "cardsExtensionProvider", () => (parcelRequire("cKAxI")).cardsExtensionProvider);
$parcel$export(module.exports, "CardsConfigPanelContent", () => (parcelRequire("5dNRq")).CardsConfigPanelContent);
$parcel$export(module.exports, "cardsHubElement", () => (parcelRequire("dwtiE")).cardsHubElement);
$parcel$export(module.exports, "CARDS_EXTENSION_TYPE", () => (parcelRequire("kcoxM")).CARDS_EXTENSION_TYPE);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE", () => (parcelRequire("kcoxM")).CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE);

var $gnpMO = parcelRequire("gnpMO");


var $cKAxI = parcelRequire("cKAxI");


var $5dNRq = parcelRequire("5dNRq");


var $dwtiE = parcelRequire("dwtiE");


var $kcoxM = parcelRequire("kcoxM");


});

parcelRegister("dwtiE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");


var $4cr8Y = parcelRequire("4cr8Y");

var $bNxOU = parcelRequire("bNxOU");


var $kcoxM = parcelRequire("kcoxM");


var $cKAxI = parcelRequire("cKAxI");


var $6Bgs5 = parcelRequire("6Bgs5");

const $23f91fd9a1963612$var$getDefaultCardsNodeAdf = (intl)=>{
    const { formatMessage: formatMessage } = intl;
    return {
        type: 'extension',
        attrs: {
            extensionKey: (0, $kcoxM.CARDS_EXTENSION_KEY),
            extensionType: (0, $kcoxM.CARDS_EXTENSION_TYPE),
            parameters: (0, $cKAxI.getCardsExtensionParameters)({
                extensionTitle: formatMessage((0, $6Bgs5.messages).cardsTitle)
            })
        }
    };
};
const $23f91fd9a1963612$var$thumbnailImage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($4cr8Y))),
    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($bNxOU))),
    alt: ""
});
const $23f91fd9a1963612$export$116ba7e9efbc8ff7 = {
    extensionKey: (0, $kcoxM.CARDS_EXTENSION_KEY),
    title: (0, $6Bgs5.messages).cardsTitle,
    description: (0, $6Bgs5.messages).cardsDescription,
    Image: $23f91fd9a1963612$var$thumbnailImage,
    getNodeAdf: $23f91fd9a1963612$var$getDefaultCardsNodeAdf
};
module.exports["cardsHubElement"] = $23f91fd9a1963612$export$116ba7e9efbc8ff7;

});

parcelRegister("4cr8Y", function(module, exports) {
module.exports = new URL("cardsHubElementThumbnail.b7c5a24a.svg", import.meta.url).toString();

});

parcelRegister("bNxOU", function(module, exports) {
module.exports = new URL("cardsHubElementThumbnail-dark.db653c30.svg", import.meta.url).toString();

});

parcelRegister("6Bgs5", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $929694ac915264f2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    cardsTitle: {
        id: "company-hub.cards-extension.cards.hub-element.title",
        defaultMessage: "Cards"
    },
    cardsDescription: {
        id: "company-hub.cards-extension.cards.hub-element.description",
        defaultMessage: "Present links, images and more"
    }
});
module.exports["messages"] = $929694ac915264f2$export$defe85febe8b728c;

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("bre0g", function(module, exports) {

var $2cmfr = parcelRequire("2cmfr");

class $1d9210071da756d7$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $2cmfr.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $1d9210071da756d7$export$2e2bcd8739ae039;

});

parcelRegister("4AkKf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b83e18362be7337c33091ec68bfbcb2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $356a9dc0786a9256$var$_react = $356a9dc0786a9256$var$_interopRequireDefault((parcelRequire("42omo")));

var $356a9dc0786a9256$var$_baseNew = $356a9dc0786a9256$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $356a9dc0786a9256$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $356a9dc0786a9256$var$FilterIcon = (props)=>/*#__PURE__*/ $356a9dc0786a9256$var$_react.default.createElement($356a9dc0786a9256$var$_baseNew.default, Object.assign({
        name: "FilterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 12v1.5H5V12zm2-4.75v1.5H3v-1.5zm2-4.75V4H1V2.5z"/>`
    }, props));
$356a9dc0786a9256$var$FilterIcon.displayName = 'FilterIcon';
var $356a9dc0786a9256$var$_default = module.exports.default = $356a9dc0786a9256$var$FilterIcon;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

function $e1a1ee666860bb23$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    (0, $42omo.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $aXWIB.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) return (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("6mn0G", function(module, exports) {
function $ef5055edddfff711$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $ef5055edddfff711$export$e88cb5bfb57ce9c4;

});

parcelRegister("euACo", function(module, exports) {
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $035a46a85e451274$var$iconStyles = null;
const $035a46a85e451274$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
}; /**
    * For windows high contrast mode
    */ 
const $035a46a85e451274$var$baseHcmStyles = null;
const $035a46a85e451274$var$primaryEqualsSecondaryHcmStyles = null;
const $035a46a85e451274$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Replica of deprecated legacy icon/base
                                             *
                                             */ 
const $035a46a85e451274$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $42omo.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $035a46a85e451274$var$sizeStyles[size]
        ])
    });
});
var $035a46a85e451274$export$2e2bcd8739ae039 = $035a46a85e451274$export$f04a61298a47a40f;
module.exports["Icon"] = $035a46a85e451274$export$f04a61298a47a40f;

});

parcelRegister("kiOFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kSC7A = parcelRequire("kSC7A");


var $f8S0G = parcelRequire("f8S0G");


var $hBNGD = parcelRequire("hBNGD");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $bZKB2 = parcelRequire("bZKB2");


var $6fCTI = parcelRequire("6fCTI");

const $78f887db99bd3113$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH = '/gateway/api/v2/accessible-products';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/v2/accessible-products';
const $78f887db99bd3113$var$defaultProducts = [
    (0, $kSC7A.AvailableSitesProductType).WHITEBOARD,
    (0, $kSC7A.AvailableSitesProductType).BEACON,
    (0, $kSC7A.AvailableSitesProductType).COMPASS,
    (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
    (0, $kSC7A.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $kSC7A.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $kSC7A.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $kSC7A.AvailableSitesProductType).MERCURY,
    (0, $kSC7A.AvailableSitesProductType).OPSGENIE,
    (0, $kSC7A.AvailableSitesProductType).STATUS_PAGE,
    (0, $kSC7A.AvailableSitesProductType).ATLAS,
    (0, $kSC7A.AvailableSitesProductType).LOOM
];
const $78f887db99bd3113$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $f8S0G.default)('operational.getAvailableSitesResolve.failed', (0, $6fCTI.getOperationFailedAttributes)(err))).fire((0, $hBNGD.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $78f887db99bd3113$export$bd4055e8b60f8535 = (data)=>{
    const sites = [];
    data.products.forEach((product)=>{
        product.workspaces.forEach((workspace)=>{
            const currentSite = sites.find((site)=>site.cloudId === workspace.cloudId);
            if (currentSite) {
                currentSite.products.push(product.productId);
                return currentSite;
            }
            sites.push({
                avatarUrl: workspace.workspaceAvatarUrl,
                cloudId: workspace.cloudId,
                displayName: workspace.workspaceDisplayName,
                isVertigo: workspace.vortexMode === 'ENABLED',
                products: [
                    product.productId
                ],
                url: workspace.cloudUrl
            });
        });
    });
    return sites;
};
const $78f887db99bd3113$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isMounted = (0, $bZKB2.useIsMounted)();
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const response = await $78f887db99bd3113$var$getAccessibleProducts({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: $78f887db99bd3113$export$bd4055e8b60f8535(response.data),
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $78f887db99bd3113$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const availableSitesPath = (0, $dh538.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$AVAILABLE_SITES_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${availableSitesPath}` : availableSitesPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
async function $78f887db99bd3113$var$getAccessibleProducts({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const accessibleProductsPath = (0, $dh538.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            productIds: products,
            permissionIds: []
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${accessibleProductsPath}` : accessibleProductsPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
module.exports["useAvailableSites"] = $78f887db99bd3113$export$3738ff0cbe469211;
module.exports["mapAccessibleProductsToAvailableSites"] = $78f887db99bd3113$export$bd4055e8b60f8535;
module.exports["useAvailableSitesV2"] = $78f887db99bd3113$export$3f59b707a86875c4;

});

parcelRegister("kSC7A", function(module, exports) {
var $2f440bf1e6112d68$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $2f440bf1e6112d68$export$16bdf84263b17cf0;

});

parcelRegister("f8S0G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::bf8c5828b0e062cbddf6092143efece2>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $4a22b51dcbeecd57$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $4a22b51dcbeecd57$export$2e2bcd8739ae039 = $4a22b51dcbeecd57$var$createEventPayload;
module.exports["default"] = $4a22b51dcbeecd57$export$2e2bcd8739ae039;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("bZKB2", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d79b64f48ff0234f$export$80c2a3957bcb42ea() {
    const isMounted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $42omo.useCallback)(()=>isMounted.current, []);
}
module.exports["useIsMounted"] = $d79b64f48ff0234f$export$80c2a3957bcb42ea;

});

parcelRegister("6fCTI", function(module, exports) {

var $6mn0G = parcelRequire("6mn0G");

const $9cbe6bde573cd7a4$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $9cbe6bde573cd7a4$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $6mn0G.getTraceId)(error),
        status: error.status,
        path: $9cbe6bde573cd7a4$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $9cbe6bde573cd7a4$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9cbe6bde573cd7a4$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$9cbe6bde573cd7a4$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $9cbe6bde573cd7a4$export$b2d107ab31565d0b;

});

parcelRegister("7dyLS", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $lEY55 = parcelRequire("lEY55");


var $iUYhn = parcelRequire("iUYhn");


var $eFiFf = parcelRequire("eFiFf");


var $3YFt4 = parcelRequire("3YFt4");

var $ff4c1fab1412a389$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $ff4c1fab1412a389$export$775b6bb06e53a214 = {
    ...(0, $lEY55.Scope),
    ...(0, $iUYhn.Scope),
    ...(0, $3YFt4.TownsquareScope),
    ...(0, $eFiFf.Scope)
};
module.exports["Scope"] = $ff4c1fab1412a389$export$775b6bb06e53a214;

});

parcelRegister("lEY55", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $31e4730094d25be0$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $31e4730094d25be0$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $31e4730094d25be0$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $31e4730094d25be0$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $31e4730094d25be0$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $31e4730094d25be0$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $31e4730094d25be0$export$80a5be864676016b = 'confluence.space';
const $31e4730094d25be0$export$70542451ad6057d2 = 'urs.user-confluence';
const $31e4730094d25be0$export$6ec00f56b27cdc1d = 'generic-container-result';
const $31e4730094d25be0$export$ca1a50bc869949e = 'person-result';
const $31e4730094d25be0$export$a99961038e9d5471 = 'confluence-object-result';
const $31e4730094d25be0$export$18c69de2b4aa679c = 'recent-confluence';
const $31e4730094d25be0$export$dc31f0db54ab1a30 = 'result-confluence';
const $31e4730094d25be0$export$cb8b6c470492bee8 = 'recent-person';
const $31e4730094d25be0$export$ebb42dafe7a39a20 = 'result-person';
const $31e4730094d25be0$export$602b44a55c824e30 = 'advanced-search-confluence';
const $31e4730094d25be0$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $31e4730094d25be0$export$bbd1709e62826142 = 'confluence-page';
const $31e4730094d25be0$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $31e4730094d25be0$export$b441f0c13fd510b9 = 'confluence-attachment';
const $31e4730094d25be0$export$8ee8726ca4e2f8bd = 'confluence-space';
const $31e4730094d25be0$export$d0e824889e01c751 = 'person';
const $31e4730094d25be0$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $31e4730094d25be0$export$775b6bb06e53a214;

});

parcelRegister("iUYhn", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $4cce666965dd4176$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $4cce666965dd4176$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $4cce666965dd4176$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $4cce666965dd4176$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $4cce666965dd4176$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $4cce666965dd4176$export$775b6bb06e53a214;

});

parcelRegister("eFiFf", function(module, exports) {
var $e9e0239fba21ef53$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $e9e0239fba21ef53$export$775b6bb06e53a214;

});

parcelRegister("3YFt4", function(module, exports) {
var $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa;

});

parcelRegister("3paC4", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $jppmC = parcelRequire("jppmC");

const $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY = 3;
const $6b372c322d10f06f$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY);
};
class $6b372c322d10f06f$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $6b372c322d10f06f$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $jppmC.timed)(this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $6b372c322d10f06f$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $6b372c322d10f06f$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $6b372c322d10f06f$export$5d730b7aed1a3eb0;

});

parcelRegister("jppmC", function(module, exports) {
const $e3bb250125deb745$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $e3bb250125deb745$export$d35186a762cd39c8;

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("57Wda", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::599e4be29a2a39bcbf5cf9b372d0e03e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $6B0jU = parcelRequire("6B0jU");


var $kXb3C = parcelRequire("kXb3C");

function $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $02745cd2b6b0665c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

function $02745cd2b6b0665c$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("eQfRp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $26650821103220c8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a634b13ea98c89a9c27945d37a8a7571>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $ZDq1z = parcelRequire("ZDq1z");


var $kXb3C = parcelRequire("kXb3C");

function $26650821103220c8$export$2e2bcd8739ae039({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
}

});

parcelRegister("d2kvf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1HnpQ = parcelRequire("1HnpQ");


var $i3GYc = parcelRequire("i3GYc");

// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $7cea5ab07179eb6f$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $i3GYc.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1HnpQ.default), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children));
};
var $7cea5ab07179eb6f$export$2e2bcd8739ae039 = $7cea5ab07179eb6f$var$TabPanel;
module.exports["default"] = $7cea5ab07179eb6f$export$2e2bcd8739ae039;

});

parcelRegister("e3TOY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5ae331244e5ce5f0d911605ea315070>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3cca56e09704fd9$var$_react = $a3cca56e09704fd9$var$_interopRequireDefault((parcelRequire("42omo")));

var $a3cca56e09704fd9$var$_baseNew = $a3cca56e09704fd9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a3cca56e09704fd9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Audio".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/audio
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3cca56e09704fd9$var$AudioIcon = (props)=>/*#__PURE__*/ $a3cca56e09704fd9$var$_react.default.createElement($a3cca56e09704fd9$var$_baseNew.default, Object.assign({
        name: "AudioIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.746 1.188A.75.75 0 0 1 15 1.75V11a3 3 0 1 1-3-3h1.5V5.85L7 6.662V12a3 3 0 1 1-3-3h1.5V2.75a.75.75 0 0 1 .657-.744l8-1a.75.75 0 0 1 .59.182M5.5 10.5H4A1.5 1.5 0 1 0 5.5 12zM7 5.15l6.5-.812V2.6L7 3.412zm6.5 4.35H12a1.5 1.5 0 1 0 1.5 1.5z" clip-rule="evenodd"/>`
    }, props));
$a3cca56e09704fd9$var$AudioIcon.displayName = 'AudioIcon';
var $a3cca56e09704fd9$var$_default = module.exports.default = $a3cca56e09704fd9$var$AudioIcon;

});

parcelRegister("2ixko", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ac71d7218c06efe$var$_react = $1ac71d7218c06efe$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $1ac71d7218c06efe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ac71d7218c06efe$var$Executable16Icon = (props)=>/*#__PURE__*/ $1ac71d7218c06efe$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zm3 6.72v3.572c0 .394.32.714.714.714h8.572c.394 0 .714-.32.714-.714V8.714zM4.345 3a.714.714 0 0 0-.709.626L3 8.714h10l-.636-5.088A.714.714 0 0 0 11.655 3zm.798 7.143h5.714a.714.714 0 0 1 0 1.428H5.143a.714.714 0 1 1 0-1.428"/></svg>`
    }, props, {
        size: 'small'
    }));
$1ac71d7218c06efe$var$Executable16Icon.displayName = 'Executable16Icon';
var $1ac71d7218c06efe$var$_default = module.exports.default = $1ac71d7218c06efe$var$Executable16Icon;

});

parcelRegister("4dLYc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $312d962237f997a8$var$_react = $312d962237f997a8$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $312d962237f997a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $312d962237f997a8$var$Executable24Icon = (props)=>/*#__PURE__*/ $312d962237f997a8$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$312d962237f997a8$var$Executable24Icon.displayName = 'Executable24Icon';
var $312d962237f997a8$var$_default = module.exports.default = $312d962237f997a8$var$Executable24Icon;

});

parcelRegister("4rkAw", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $33b9a76c1d425a4b$var$_react = $33b9a76c1d425a4b$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $33b9a76c1d425a4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $33b9a76c1d425a4b$var$GoogleDoc16Icon = (props)=>/*#__PURE__*/ $33b9a76c1d425a4b$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$33b9a76c1d425a4b$var$GoogleDoc16Icon.displayName = 'GoogleDoc16Icon';
var $33b9a76c1d425a4b$var$_default = module.exports.default = $33b9a76c1d425a4b$var$GoogleDoc16Icon;

});

parcelRegister("5W6v1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $45276929af089f1e$var$_react = $45276929af089f1e$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $45276929af089f1e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $45276929af089f1e$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $45276929af089f1e$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$45276929af089f1e$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $45276929af089f1e$var$_default = module.exports.default = $45276929af089f1e$var$GoogleDoc24Icon;

});

parcelRegister("jDMpf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e4c73548be2d77b2$var$_react = $e4c73548be2d77b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $e4c73548be2d77b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e4c73548be2d77b2$var$GoogleForm16Icon = (props)=>/*#__PURE__*/ $e4c73548be2d77b2$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e4c73548be2d77b2$var$GoogleForm16Icon.displayName = 'GoogleForm16Icon';
var $e4c73548be2d77b2$var$_default = module.exports.default = $e4c73548be2d77b2$var$GoogleForm16Icon;

});

parcelRegister("av4P2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7a508a3974c868b6$var$_react = $7a508a3974c868b6$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $7a508a3974c868b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7a508a3974c868b6$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $7a508a3974c868b6$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$7a508a3974c868b6$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $7a508a3974c868b6$var$_default = module.exports.default = $7a508a3974c868b6$var$GoogleForm24Icon;

});

parcelRegister("l59oX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f5915b8e34e2cce4$var$_react = $f5915b8e34e2cce4$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $f5915b8e34e2cce4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f5915b8e34e2cce4$var$GoogleSheet16Icon = (props)=>/*#__PURE__*/ $f5915b8e34e2cce4$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$f5915b8e34e2cce4$var$GoogleSheet16Icon.displayName = 'GoogleSheet16Icon';
var $f5915b8e34e2cce4$var$_default = module.exports.default = $f5915b8e34e2cce4$var$GoogleSheet16Icon;

});

parcelRegister("giYeH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $bded0d6c49d90549$var$_react = $bded0d6c49d90549$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $bded0d6c49d90549$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bded0d6c49d90549$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $bded0d6c49d90549$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$bded0d6c49d90549$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $bded0d6c49d90549$var$_default = module.exports.default = $bded0d6c49d90549$var$GoogleSheet24Icon;

});

parcelRegister("jOGxt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e6d3af3126d12bf0$var$_react = $e6d3af3126d12bf0$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $e6d3af3126d12bf0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6d3af3126d12bf0$var$GoogleSlide16Icon = (props)=>/*#__PURE__*/ $e6d3af3126d12bf0$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8.287 2.5-4.067.04 3.508 6.114 4.066-.041zM2 9.33l2.068 3.523L7.576 6.74 5.508 3.217zm4.984.106L4.987 13h7.015L14 9.437z"/></svg>`
    }, props, {
        size: 'small'
    }));
$e6d3af3126d12bf0$var$GoogleSlide16Icon.displayName = 'GoogleSlide16Icon';
var $e6d3af3126d12bf0$var$_default = module.exports.default = $e6d3af3126d12bf0$var$GoogleSlide16Icon;

});

parcelRegister("eWLPt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $ae1b9556e1933b44$var$_react = $ae1b9556e1933b44$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $ae1b9556e1933b44$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae1b9556e1933b44$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $ae1b9556e1933b44$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$ae1b9556e1933b44$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $ae1b9556e1933b44$var$_default = module.exports.default = $ae1b9556e1933b44$var$GoogleSlide24Icon;

});

parcelRegister("d8Kpd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $991004eb95b782af$var$_react = $991004eb95b782af$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $991004eb95b782af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $991004eb95b782af$var$ExcelSpreadsheet16Icon = (props)=>/*#__PURE__*/ $991004eb95b782af$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM4.858 10.2l1.35-2.13-1.341-2.098h1.04l.881 1.48h.053l.89-1.48h.991L7.33 8.085 8.702 10.2H7.694l-.908-1.433h-.053l-.92 1.433z"/></svg>`
    }, props, {
        size: 'small'
    }));
$991004eb95b782af$var$ExcelSpreadsheet16Icon.displayName = 'ExcelSpreadsheet16Icon';
var $991004eb95b782af$var$_default = module.exports.default = $991004eb95b782af$var$ExcelSpreadsheet16Icon;

});

parcelRegister("gH8Rx", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c277896da6578a99$var$_react = $c277896da6578a99$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $c277896da6578a99$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c277896da6578a99$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $c277896da6578a99$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c277896da6578a99$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $c277896da6578a99$var$_default = module.exports.default = $c277896da6578a99$var$ExcelSpreadsheet24Icon;

});

parcelRegister("hY1Uy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d14985c3ed2ec0ae$var$_react = $d14985c3ed2ec0ae$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $d14985c3ed2ec0ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon = (props)=>/*#__PURE__*/ $d14985c3ed2ec0ae$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM5.313 6.072h1.763c.87 0 1.465.583 1.465 1.462 0 .87-.618 1.454-1.509 1.454h-.835V10.3h-.884zm.884.727v1.47h.642c.507 0 .803-.257.803-.732 0-.48-.29-.738-.8-.738z"/></svg>`
    }, props, {
        size: 'small'
    }));
$d14985c3ed2ec0ae$var$PowerpointPresentation16Icon.displayName = 'PowerpointPresentation16Icon';
var $d14985c3ed2ec0ae$var$_default = module.exports.default = $d14985c3ed2ec0ae$var$PowerpointPresentation16Icon;

});

parcelRegister("dfQbH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9a652876e1a65311$var$_react = $9a652876e1a65311$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $9a652876e1a65311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a652876e1a65311$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $9a652876e1a65311$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9a652876e1a65311$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $9a652876e1a65311$var$_default = module.exports.default = $9a652876e1a65311$var$PowerpointPresentation24Icon;

});

parcelRegister("90Icb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $68f6656ee3eec0b2$var$_react = $68f6656ee3eec0b2$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $68f6656ee3eec0b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $68f6656ee3eec0b2$var$WordDocument16Icon = (props)=>/*#__PURE__*/ $68f6656ee3eec0b2$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.235 4.258A.27.27 0 0 0 3 4.53v6.969c0 .136.1.252.236.27l6.953.962a.273.273 0 0 0 .311-.271V3.542a.273.273 0 0 0-.312-.27zm7.89.617v6.25h1.563c.172 0 .312-.14.312-.312V5.187a.31.31 0 0 0-.312-.312zM6.803 7.602 6.012 10.4h-.835l-1.12-4.228h.92l.66 2.98h.047l.77-2.98h.747l.786 2.98h.046l.654-2.98H9.6L8.479 10.4h-.83l-.8-2.798z"/></svg>`
    }, props, {
        size: 'small'
    }));
$68f6656ee3eec0b2$var$WordDocument16Icon.displayName = 'WordDocument16Icon';
var $68f6656ee3eec0b2$var$_default = module.exports.default = $68f6656ee3eec0b2$var$WordDocument16Icon;

});

parcelRegister("lkBga", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $f8785e41f79a32cd$var$_react = $f8785e41f79a32cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $f8785e41f79a32cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f8785e41f79a32cd$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $f8785e41f79a32cd$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$f8785e41f79a32cd$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $f8785e41f79a32cd$var$_default = module.exports.default = $f8785e41f79a32cd$var$WordDocument24Icon;

});

parcelRegister("11LZV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0bfb1dce28d59ddd$var$_react = $0bfb1dce28d59ddd$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $0bfb1dce28d59ddd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0bfb1dce28d59ddd$var$PdfDocument16Icon = (props)=>/*#__PURE__*/ $0bfb1dce28d59ddd$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1.23 8.113h.323c.744 0 .802-.214.802-.517 0-.346-.179-.514-.545-.514h-.58zm4.194 1.456h.443c.494 0 1-.147 1-1.237 0-1.1-.534-1.24-1-1.24h-.443zM2.975 10.66h-.72A.256.256 0 0 1 2 10.404V6.255c0-.14.114-.255.255-.255h1.663c.989 0 1.68.656 1.68 1.596 0 .953-.677 1.593-1.683 1.593H3.23v1.215a.256.256 0 0 1-.256.256m4.968 0H6.448a.256.256 0 0 1-.255-.256V6.255c0-.14.114-.255.255-.255h1.495c1.404 0 2.178.825 2.178 2.323 0 1.507-.774 2.337-2.178 2.337m3.85 0h-.72a.256.256 0 0 1-.256-.256V6.255c0-.14.114-.255.255-.255h2.673c.14 0 .255.115.255.255v.587a.256.256 0 0 1-.255.255h-1.697v.76h1.528c.141 0 .255.115.255.256v.577c0 .14-.114.256-.255.256h-1.528v1.458a.256.256 0 0 1-.255.256"/></svg>`
    }, props, {
        size: 'small'
    }));
$0bfb1dce28d59ddd$var$PdfDocument16Icon.displayName = 'PdfDocument16Icon';
var $0bfb1dce28d59ddd$var$_default = module.exports.default = $0bfb1dce28d59ddd$var$PdfDocument16Icon;

});

parcelRegister("lzyQK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fb47e6517d9f8e39$var$_react = $fb47e6517d9f8e39$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $fb47e6517d9f8e39$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb47e6517d9f8e39$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $fb47e6517d9f8e39$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$fb47e6517d9f8e39$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $fb47e6517d9f8e39$var$_default = module.exports.default = $fb47e6517d9f8e39$var$PdfDocument24Icon;

});

parcelRegister("9W0IA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $73ba16739a647a26$var$_react = $73ba16739a647a26$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $73ba16739a647a26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $73ba16739a647a26$var$Sketch16Icon = (props)=>/*#__PURE__*/ $73ba16739a647a26$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6.02 13.333a.67.67 0 0 0 .502-.228L13.17 7.77a.67.67 0 0 0 .063-.79l-1.657-2.666A.67.67 0 0 0 11.01 4H5.116a.67.67 0 0 0-.554.296L2.779 6.963a.67.67 0 0 0 .054.81l4.686 5.334a.67.67 0 0 0 .5.226"/></svg>`
    }, props, {
        size: 'small'
    }));
$73ba16739a647a26$var$Sketch16Icon.displayName = 'Sketch16Icon';
var $73ba16739a647a26$var$_default = module.exports.default = $73ba16739a647a26$var$Sketch16Icon;

});

parcelRegister("9AnKp", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6fa9e5979f68da4f$var$_react = $6fa9e5979f68da4f$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $6fa9e5979f68da4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6fa9e5979f68da4f$var$Sketch24Icon = (props)=>/*#__PURE__*/ $6fa9e5979f68da4f$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6fa9e5979f68da4f$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $6fa9e5979f68da4f$var$_default = module.exports.default = $6fa9e5979f68da4f$var$Sketch24Icon;

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
}

});

parcelRegister("922yL", function(module, exports) {
$parcel$export(module.exports, "default", () => $6936494635ea8bcb$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6936494635ea8bcb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("ghphD", function(module, exports) {
$parcel$export(module.exports, "default", () => $bda1d8a3686c6d03$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $jZ39j = parcelRequire("jZ39j");


var $b5utg = parcelRequire("b5utg");


var $2h3f7 = parcelRequire("2h3f7");

function $bda1d8a3686c6d03$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(1, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var weekStartsOn = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("e1kiJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a350e81639ab5a88$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $922yL = parcelRequire("922yL");


var $b5utg = parcelRequire("b5utg");

function $a350e81639ab5a88$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $922yL.default)(dirtyDate, days);
}

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("6gF1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $49040fbe3dc0e481$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $e1kiJ = parcelRequire("e1kiJ");


var $b5utg = parcelRequire("b5utg");

function $49040fbe3dc0e481$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $e1kiJ.default)(dirtyDate, -amount);
}

});

parcelRegister("2WHHL", function(module, exports) {
const $4de09c96514ff692$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $4de09c96514ff692$var$uniqueKey = Symbol('closestEdge');
function $4de09c96514ff692$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $4de09c96514ff692$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$4de09c96514ff692$var$uniqueKey]: addClosestEdge
    };
}
function $4de09c96514ff692$export$945a571f3b658bf(userData) {
    return userData[$4de09c96514ff692$var$uniqueKey] ?? null;
}
module.exports["attachClosestEdge"] = $4de09c96514ff692$export$f0cafff222395e89;
module.exports["extractClosestEdge"] = $4de09c96514ff692$export$945a571f3b658bf;

});

parcelRegister("5TGLQ", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $aw01o = parcelRequire("aw01o");


var $a6FC8 = parcelRequire("a6FC8");

const $0aa0cd7558ee373c$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $aw01o.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a6FC8.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $0aa0cd7558ee373c$export$ea56ca58f08ffa52;

});

parcelRegister("gL6du", function(module, exports) {
const $21e9301be8cff986$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $21e9301be8cff986$export$dca0327c9b9c6498;

});

parcelRegister("aw01o", function(module, exports) {

var $gL6du = parcelRequire("gL6du");


var $3nGJd = parcelRequire("3nGJd");


var $4eigd = parcelRequire("4eigd");


var $2iEso = parcelRequire("2iEso");

const $734802129a3b7f4d$var$INVALID_DATE = new Date(NaN);
const $734802129a3b7f4d$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $734802129a3b7f4d$var$INVARIANT_DATE = (0, $2iEso.toDate)($734802129a3b7f4d$var$INVARIANT);
const $734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $734802129a3b7f4d$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $734802129a3b7f4d$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $734802129a3b7f4d$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $734802129a3b7f4d$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $gL6du.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($734802129a3b7f4d$var$INVARIANT_DATE);
    const shortDate = $734802129a3b7f4d$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($734802129a3b7f4d$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $734802129a3b7f4d$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($734802129a3b7f4d$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $734802129a3b7f4d$var$stripExtras(date).match($734802129a3b7f4d$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $734802129a3b7f4d$var$INVALID_DATE;
        const dateParts = $734802129a3b7f4d$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $4eigd.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3nGJd.isValid)(normalizedDate)) return $734802129a3b7f4d$var$INVALID_DATE;
        return (0, $2iEso.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $734802129a3b7f4d$export$cfa2ef2687faeda2;

});

parcelRegister("3nGJd", function(module, exports) {

var $7sNuF = parcelRequire("7sNuF");

const $7f0fa5875d6e9a42$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $7sNuF.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $7f0fa5875d6e9a42$export$1ea939691cdc45b8;

});

parcelRegister("7sNuF", function(module, exports) {

var $1RvqY = parcelRequire("1RvqY");

const $320ec45740b0ee24$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $1RvqY.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $320ec45740b0ee24$export$f645ddd439eb259d;

});

parcelRegister("1RvqY", function(module, exports) {
const $323f2e4da88832b7$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $323f2e4da88832b7$export$553d7fa8e3805fc0;

});

parcelRegister("4eigd", function(module, exports) {

var $aKKC5 = parcelRequire("aKKC5");

const $927e6bf7203913f7$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $aKKC5.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $927e6bf7203913f7$export$fcc71269590ba0a8;

});

parcelRegister("aKKC5", function(module, exports) {
const $00e4455f9b4cd7ae$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $00e4455f9b4cd7ae$export$abe96da78d4f59dd;

});

parcelRegister("2iEso", function(module, exports) {
const $f36e5bfee980e3d5$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $f36e5bfee980e3d5$export$e67a095c620b86fe;

});

parcelRegister("a6FC8", function(module, exports) {
const $5e4f9944cbc7c90e$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $5e4f9944cbc7c90e$export$9b7ca29af37c192;

});

parcelRegister("8lMgE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6145b9d2a216bb48$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6145b9d2a216bb48$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $egXhZ.default)(dirtyDate).getFullYear();
}

});

parcelRegister("882hS", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("85Mv7")).pointerOutsideOfPreview);

var $85Mv7 = parcelRequire("85Mv7");


});

parcelRegister("85Mv7", function(module, exports) {

var $ic3Jg = parcelRequire("ic3Jg");


var $iFRCn = parcelRequire("iFRCn");


var $76xc7 = parcelRequire("76xc7");

function $30069a8958953d8b$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $iFRCn.isSafariOnIOS)() || (0, $ic3Jg.isAndroid)()) return (0, $76xc7.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $30069a8958953d8b$export$427e20518819fabc;

});

parcelRegister("iFRCn", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");


var $e880Z = parcelRequire("e880Z");

const $3720fb1a551ae595$export$52fc40c68fea4952 = (0, $aYpzB.once)(function isSafariOnIOS() {
    return (0, $e880Z.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $3720fb1a551ae595$export$52fc40c68fea4952;

});

parcelRegister("76xc7", function(module, exports) {
const $54acc06d1c628398$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $54acc06d1c628398$export$81d8e72a15eef435;

});

parcelRegister("afUmf", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("3ts5j")).setCustomNativeDragPreview);

var $3ts5j = parcelRequire("3ts5j");


});

parcelRegister("3ts5j", function(module, exports) {

var $3CnSH = parcelRequire("3CnSH");


var $e880Z = parcelRequire("e880Z");


var $f7qXf = parcelRequire("f7qXf");


var $hSdmP = parcelRequire("hSdmP");


var $j4IDJ = parcelRequire("j4IDJ");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $90430ceac724b72d$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $90430ceac724b72d$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $90430ceac724b72d$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $j4IDJ.supportsPopover)()) container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $j4IDJ.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $hSdmP.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $f7qXf.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $j4IDJ.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ /**
		 * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
		 * We can remove it in a future release
		 */ if ((0, $e880Z.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $3CnSH.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $90430ceac724b72d$export$52d889c66db0f96e;

});

parcelRegister("iTTcV", function(module, exports) {
parcelRequire("d4P2q");
var $lFaps = parcelRequire("lFaps");


var $7XdU2 = parcelRequire("7XdU2");

function $57c56c1fb9914734$export$d0bc664d2812b3ba({ list: list, startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    return (0, $lFaps.reorder)({
        list: list,
        startIndex: startIndex,
        finishIndex: (0, $7XdU2.getReorderDestinationIndex)({
            closestEdgeOfTarget: closestEdgeOfTarget,
            startIndex: startIndex,
            indexOfTarget: indexOfTarget,
            axis: axis
        })
    });
}
module.exports["reorderWithEdge"] = $57c56c1fb9914734$export$d0bc664d2812b3ba;

});

parcelRegister("d4P2q", function(module, exports) {
$parcel$export(module.exports, "reorder", () => (parcelRequire("lFaps")).reorder);

var $lFaps = parcelRequire("lFaps");


});

parcelRegister("lFaps", function(module, exports) {
/**
 * A function that will reorder an array (`list`).
 * `reorder` returns a new array with reordered items and does not
 *  modify the original array. The items in the array are also not modified.
 */ function $2e6a223576f565f2$export$fc77a6137e3f91c({ list: list, startIndex: startIndex, finishIndex: finishIndex }) {
    if (startIndex === -1 || finishIndex === -1) // Making this function consistently return a new array reference.
    // This is consistent with .toSorted() which always returns a new array
    // even when it does not do anything
    return Array.from(list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(finishIndex, 0, removed);
    return result;
}
module.exports["reorder"] = $2e6a223576f565f2$export$fc77a6137e3f91c;

});

parcelRegister("7XdU2", function(module, exports) {
function $68bcb6b8502e57f3$export$846f792f51b92b6e({ startIndex: startIndex, closestEdgeOfTarget: closestEdgeOfTarget, indexOfTarget: indexOfTarget, axis: axis }) {
    // invalid index's
    if (startIndex === -1 || indexOfTarget === -1) return startIndex;
    // if we are targeting the same index we don't need to do anything
    if (startIndex === indexOfTarget) return startIndex;
    if (closestEdgeOfTarget == null) return indexOfTarget;
    const isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
    const isMovingForward = startIndex < indexOfTarget;
    // moving forward
    if (isMovingForward) return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
    // moving backwards
    return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}
module.exports["getReorderDestinationIndex"] = $68bcb6b8502e57f3$export$846f792f51b92b6e;

});

parcelRegister("bbypI", function(module, exports) {
/* checkbox-option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6lY6Z = parcelRequire("6lY6Z");

const $4804f2e382a4a42f$var$svgStyles = null;
const $4804f2e382a4a42f$var$CheckboxIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ $42omo.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $42omo.createElement("rect", {
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })));
};
const $4804f2e382a4a42f$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ $42omo.createElement((0, $6lY6Z.ControlOption), {
        Icon: $4804f2e382a4a42f$var$CheckboxIcon,
        ...props
    });
module.exports["CheckboxOption"] = $4804f2e382a4a42f$export$d40cc97ecda916f9;

});

parcelRegister("6lY6Z", function(module, exports) {
/* control-option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $bd4024c8312e5300$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    disabled: "_syaz1gmx"
}; // state of the parent option
const $bd4024c8312e5300$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #17171708)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
}; // the secondary color represents the radio dot or checkmark
const $bd4024c8312e5300$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $bd4024c8312e5300$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $bd4024c8312e5300$var$baseIconStyles = null;
const $bd4024c8312e5300$var$baseOptionStyles = null;
const $bd4024c8312e5300$export$e41f7c07e51665da = (props)=>{
    const [isActive, setIsActive] = (0, $42omo.useState)(false);
    const onMouseDown = (0, $42omo.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $42omo.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $42omo.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            $bd4024c8312e5300$var$optionStyles.default,
            isFocused && $bd4024c8312e5300$var$optionStyles.focused,
            isDisabled && $bd4024c8312e5300$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseUp,
        ...innerProps
    }, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
            isSelected || isActive || isDisabled ? $bd4024c8312e5300$var$iconStyles.inherit : $bd4024c8312e5300$var$iconStyles.default
        ])
    }, !!Icon ? /*#__PURE__*/ $42omo.createElement(Icon, {
        label: "",
        primaryColor: $bd4024c8312e5300$var$getPrimaryColor({
            isDisabled: isDisabled,
            isSelected: isSelected,
            isFocused: isFocused,
            isActive: isActive
        }),
        secondaryColor: $bd4024c8312e5300$var$getSecondaryColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        isFacadeDisabled: true
    }) : null), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
module.exports["ControlOption"] = $bd4024c8312e5300$export$e41f7c07e51665da;

});

parcelRegister("2n8po", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $31bj1 = parcelRequire("31bj1");


var $9JSVA = parcelRequire("9JSVA");

function $f0c37d2844a91b76$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $31bj1.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$f0c37d2844a91b76$export$2e2bcd8739ae039 = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["default"] = $f0c37d2844a91b76$export$2e2bcd8739ae039;

});

parcelRegister("31bj1", function(module, exports) {
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $1707735fc36ab082$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $1707735fc36ab082$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $1707735fc36ab082$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $1707735fc36ab082$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $1707735fc36ab082$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $1707735fc36ab082$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $1707735fc36ab082$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $gMc0m.default)([
            $1707735fc36ab082$var$baseStyles.root,
            $1707735fc36ab082$var$orientationStyles[orientation],
            $1707735fc36ab082$var$edgeStyles[edge]
        ])
    });
} // For React.lazy
var $1707735fc36ab082$export$2e2bcd8739ae039 = $1707735fc36ab082$export$17d680238e50603e;
module.exports["Line"] = $1707735fc36ab082$export$17d680238e50603e;

});

parcelRegister("9JSVA", function(module, exports) {
const $795a0d6001dc944e$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $795a0d6001dc944e$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $795a0d6001dc944e$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $795a0d6001dc944e$export$45db03aa04b685e3;

});

parcelRegister("i2CQL", function(module, exports) {

var $g99e4 = parcelRequire("g99e4");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $g99e4.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("g99e4", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $bc14a4aa688fca7b$export$6ccbb43953eebf8);

var $9mu1x = parcelRequire("9mu1x");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $bc14a4aa688fca7b$import_meta = Object.assign(Object.create(null), {
    url: "file:///../platform/node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $bc14a4aa688fca7b$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = false;
const $bc14a4aa688fca7b$var$identity = (arg)=>arg;
function $bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector = $bc14a4aa688fca7b$var$identity, equalityFn) {
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$bc14a4aa688fca7b$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = true;
    }
    const slice = $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $bc14a4aa688fca7b$var$useDebugValue(slice);
    return slice;
}
const $bc14a4aa688fca7b$var$createImpl = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $9mu1x.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $bc14a4aa688fca7b$export$185802fd694ee1f5 = (createState)=>createState ? $bc14a4aa688fca7b$var$createImpl(createState) : $bc14a4aa688fca7b$var$createImpl;
var $bc14a4aa688fca7b$export$2e2bcd8739ae039 = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $bc14a4aa688fca7b$export$185802fd694ee1f5(createState);
};

});

parcelRegister("7YEWU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0545074a7ad6867d320b793a6025aac2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cede6a65f901a4e$var$_react = $5cede6a65f901a4e$var$_interopRequireDefault((parcelRequire("42omo")));

var $5cede6a65f901a4e$var$_baseNew = $5cede6a65f901a4e$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $5cede6a65f901a4e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPause".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5cede6a65f901a4e$var$VideoPauseIcon = (props)=>/*#__PURE__*/ $5cede6a65f901a4e$var$_react.default.createElement($5cede6a65f901a4e$var$_baseNew.default, Object.assign({
        name: "VideoPauseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$5cede6a65f901a4e$var$VideoPauseIcon.displayName = 'VideoPauseIcon';
var $5cede6a65f901a4e$var$_default = module.exports.default = $5cede6a65f901a4e$var$VideoPauseIcon;

});

parcelRegister("epp7s", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $7LI5V = parcelRequire("7LI5V");

const $e33d3ee04b17cdae$var$snapToStep = (value, min, step)=>{
    // Normalise the value to allow for division properly with different min values
    const adjustedValue = value - min;
    // Find the number of steps the value covers
    const numSteps = Math.round(adjustedValue / step);
    // Convert numSteps back into original range
    return numSteps * step + min;
};
const $e33d3ee04b17cdae$var$getRoundedPercentValue = (value, min, max, step)=>{
    let percent = '0';
    if (min < max && value > min) {
        const snappedValue = $e33d3ee04b17cdae$var$snapToStep(value, min, step);
        percent = ((snappedValue - min) / (max - min) * 100).toFixed(2);
    }
    return percent;
};
const $e33d3ee04b17cdae$var$noop = (0, $ee7An.default);
/**
 * __Range__
 *
 * A range lets users choose an approximate value on a slider.
 *
 * - [Examples](https://atlassian.design/components/range/examples)
 * - [Code](https://atlassian.design/components/range/code)
 * - [Usage](https://atlassian.design/components/range/usage)
 */ const $e33d3ee04b17cdae$var$Range = /*#__PURE__*/ (0, $42omo.forwardRef)(function Range(props, ref) {
    const { isDisabled: isDisabled = false, defaultValue: defaultValue = 50, max: max = 100, min: min = 0, onChange: onChange = $e33d3ee04b17cdae$var$noop, step: step = 1, value: propsValue, testId: testId, ...rest } = props;
    const spreadProps = {
        max: max,
        min: min,
        step: step,
        ref: ref,
        ...rest
    };
    const [value, setValue] = (0, $42omo.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const handleChange = (0, $42omo.useCallback)((e)=>{
        const newValue = Number(e.target.value);
        setValue(newValue);
        // Note use of newValue to ensure up=to-date value is used
        onChange(newValue);
    }, [
        onChange
    ]);
    const renderValue = propsValue !== undefined ? propsValue : value;
    const valuePercent = $e33d3ee04b17cdae$var$getRoundedPercentValue(renderValue, min, max, step);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7LI5V.Input), {
        type: "range",
        disabled: isDisabled,
        onChange: handleChange,
        value: renderValue,
        valuePercent: valuePercent,
        "data-testid": testId,
        ...spreadProps
    });
});
var $e33d3ee04b17cdae$export$2e2bcd8739ae039 = $e33d3ee04b17cdae$var$Range;
module.exports["default"] = $e33d3ee04b17cdae$export$2e2bcd8739ae039;

});

parcelRegister("7LI5V", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $024c7b240527c31b$var$rangeHeight = 40; // Height of the range input, used for the track and thumb
const $024c7b240527c31b$var$trackHeight = 6; // Height of the track, used for the track and thumb
const $024c7b240527c31b$var$thumbSize = "var(--ds-space-200, 16px)"; // Size of the thumb, used for the thumb styles
// Styles are split up to avoid edge-cases with TS implementations between `css` and `cssMap` with some
// of these edge-case pseudo-selectors.
// Previously, in Emotion, these selectors weren't consolidated, eg. `&::webkit-thumb, &::moz-thumb`
// would not be parsed by either browser, but this may no longer be the case in Compiled
const $024c7b240527c31b$var$webkitStyles = null;
const $024c7b240527c31b$var$firefoxStyles = null;
const $024c7b240527c31b$var$baseStyles = null;
const $024c7b240527c31b$var$themeStyles = null;
const $024c7b240527c31b$var$trackStyles = {
    root: "_1bsb1osq _4t3i1ylp _kqswh2mm _14mj1qll _1ywu1ule _z0ai1y44 _1qdg1y44 _18postnw _1hfkof27 _aetrb3bt _19nq1ssb _g0nfo1yi",
    disabled: "_1peq2wxo"
};
const $024c7b240527c31b$var$rangeA11yStyles = null;
const $024c7b240527c31b$var$stylesT26Shape = null;
const $024c7b240527c31b$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { valuePercent: valuePercent, style: style, ...strippedProps } = props;
    const input = /*#__PURE__*/ $42omo.createElement("input", {
        ...strippedProps,
        style: {
            // We are creating a css variable to control the "progress" portion of the range input
            // This avoids us needing to create a new css class for each new percentage value
            '--track-fg-width': `${valuePercent}%`
        },
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1ylp _bfhk1j28 _j5dh13gf _1j552wxo _nt751r31 _49pcglyw _1hvw1o36",
            "_wstuglyw _h2ksglyw _1kdl1qll _m8f8bpmo _1yz62hjt _1bdkusvi _u98zpxbi _1j70pxbi _1esf1w0t _4w431ik2 _yfyntlke _1sdc196n _18k7v77o _1cdcglyw _10lridpf _g6tdlb4i _vi4t2hjt _1g2h1osq _168l1y44 _9u3f2hce _1g741hsc _1d8tmgnk _np53xlkz _18tdtlke _1p201osq _1yte13gf _5i7a13gf",
            "_1yq0glyw _108m1qll _1rf3bpmo _1yeu2hjt _g4ppusvi _r763pxbi _1mn5pxbi _12el1w0t _1oqe1ik2 _10o7tlke _1kzev77o _15raidpf _e8hnidpf _37ywlb4i _1tcb2hjt _aoww1osq _1kd2i2wt _vt2s1w6o _1ssqtlke _ru37idpf _1gvolb4i _1nx42hjt _1f5t1osq _142y1y44 _d7w62hce _b3fmtlke _1vq313gf _1fov13gf _34m613gf",
            "_14h1b1q9 _15dpi8nm _18lx1aqn _jxar1ibz _ydqgplhp _1jhc1ibz _1rucof27 _164c1v1w",
            "_1drqof27 _15dp1vck _18lxof27 _g6tdfajl _168li2wt _37ywfajl _1kd2i2wt _1sdc1lpd _ydqgmpja",
            (0, $dh538.fg)('platform-dst-shape-theme-default') && "_g6td1rr0 _37yw1rr0 _1gvo1rr0"
        ])
    });
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $024c7b240527c31b$var$trackStyles.root,
            strippedProps.disabled && $024c7b240527c31b$var$trackStyles.disabled
        ])
    }, input);
});
$024c7b240527c31b$export$f5b8910cec6cf069.displayName = 'InputRange';
module.exports["Input"] = $024c7b240527c31b$export$f5b8910cec6cf069;

});

parcelRegister("d4cCP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $983571389684b329$var$_react = $983571389684b329$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $983571389684b329$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $983571389684b329$var$Audio16Icon = (props)=>/*#__PURE__*/ $983571389684b329$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$983571389684b329$var$Audio16Icon.displayName = 'Audio16Icon';
var $983571389684b329$var$_default = module.exports.default = $983571389684b329$var$Audio16Icon;

});

parcelRegister("iFCP2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d97a2b9af590931e$var$_react = $d97a2b9af590931e$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $d97a2b9af590931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d97a2b9af590931e$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d97a2b9af590931e$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d97a2b9af590931e$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d97a2b9af590931e$var$_default = module.exports.default = $d97a2b9af590931e$var$Spreadsheet24Icon;

});

parcelRegister("7t8Pn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $570216d1bcbf60e3$var$_react = $570216d1bcbf60e3$var$_interopRequireDefault((parcelRequire("42omo")));

var $euACo = parcelRequire("euACo");

function $570216d1bcbf60e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $570216d1bcbf60e3$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $570216d1bcbf60e3$var$_react.default.createElement($euACo.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$570216d1bcbf60e3$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $570216d1bcbf60e3$var$_default = module.exports.default = $570216d1bcbf60e3$var$SourceCode24Icon;

});

parcelRegister("1NrSh", function(module, exports) {
const $49895188b0a86f3f$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $49895188b0a86f3f$export$d4fff2dfff3e2bc1;

});

parcelRegister("kZ5GD", function(module, exports) {
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ /// <reference types="node" />
// for typing `process`

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");

const $56d63ff022409480$var$packageName = "platform-pkg";
const $56d63ff022409480$var$packageVersion = "0.0.0-use.local";
const $56d63ff022409480$var$noop = (0, $ee7An.default);
const $56d63ff022409480$var$labelPaddingStyles = null;
const $56d63ff022409480$var$labelStyles = null;
const $56d63ff022409480$var$labelDisabledStyles = null;
const $56d63ff022409480$var$radioBaseStyles = null;
const $56d63ff022409480$var$radioInteractiveStyles = null;
const $56d63ff022409480$var$radioDisabledStyles = null;
const $56d63ff022409480$var$radioDisabledCheckedStyles = null;
const $56d63ff022409480$var$radioInvalidStyles = null;
const $56d63ff022409480$var$InnerRadio = /*#__PURE__*/ (0, $42omo.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $56d63ff022409480$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $56d63ff022409480$var$packageName,
        packageVersion: $56d63ff022409480$var$packageVersion
    });
    return /*#__PURE__*/ $42omo.createElement("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo",
            isDisabled && "_syaz1gmx _80om13gf"
        ])
    }, /*#__PURE__*/ $42omo.createElement("input", {
        ...rest,
        tabIndex: 0,
        "aria-label": ariaLabel,
        "aria-labelledby": labelId || ariaLabelledBy,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd",
            !isDisabled && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
            isDisabled && "_80om13gf _1q6qby5v _1151bk0g _1s6w2sac",
            isDisabled && isChecked && "_tqbwt94y",
            isInvalid && !isDisabled && "_1151s4qr _11jys4qr"
        ])
    }), label ? /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
        ])
    }, label) : null);
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $56d63ff022409480$var$Radio = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ $42omo.createElement($56d63ff022409480$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $56d63ff022409480$export$2e2bcd8739ae039 = $56d63ff022409480$var$Radio;
module.exports["default"] = $56d63ff022409480$export$2e2bcd8739ae039;

});

parcelRegister("10CSJ", function(module, exports) {

var $42omo = parcelRequire("42omo");



class $330e3eb3197f64f9$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            (parcelRequire("9qGWt")),
            (parcelRequire("4ysKA"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser
        };
    }
}
$330e3eb3197f64f9$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$330e3eb3197f64f9$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $330e3eb3197f64f9$export$3ce634ac4a869e2c;

});

parcelRegister("9qGWt", function(module, exports) {

let $6dd7da32a3f792e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6dd7da32a3f792e5$var$load("hRqzw"),
    $6dd7da32a3f792e5$var$load("1SgRc"),
    $6dd7da32a3f792e5$var$load("8j9XC"),
    $6dd7da32a3f792e5$var$load("6aruy")
]).then(()=>parcelRequire('9VKkC'));

});

parcelRegister("4ysKA", function(module, exports) {

let $3510a3a429df29ec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3510a3a429df29ec$var$load("8j9XC"),
    $3510a3a429df29ec$var$load("hRqzw"),
    $3510a3a429df29ec$var$load("f35QR"),
    $3510a3a429df29ec$var$load("eVYW1"),
    $3510a3a429df29ec$var$load("ls0Um"),
    $3510a3a429df29ec$var$load("020xd"),
    $3510a3a429df29ec$var$load("eTBsW"),
    $3510a3a429df29ec$var$load("bYxCZ"),
    $3510a3a429df29ec$var$load("6HBYC"),
    $3510a3a429df29ec$var$load("eDqo1"),
    $3510a3a429df29ec$var$load("lxiFd"),
    $3510a3a429df29ec$var$load("1oiJ6"),
    $3510a3a429df29ec$var$load("huUvS"),
    $3510a3a429df29ec$var$load("dT77m"),
    $3510a3a429df29ec$var$load("6vhrJ"),
    $3510a3a429df29ec$var$load("fxC6e"),
    $3510a3a429df29ec$var$load("hqblC")
]).then(()=>parcelRequire('4rZL5'));

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("hwDTW", function(module, exports) {

var $eHPLt = parcelRequire("eHPLt");


var $1WABR = parcelRequire("1WABR");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");


var $bRRFB = parcelRequire("bRRFB");


var $cSA01 = parcelRequire("cSA01");


var $erbrP = parcelRequire("erbrP");


var $gQUlr = parcelRequire("gQUlr");

/** `Object#toString` result references. */ var $cc24605e9ae7f4f1$var$mapTag = '[object Map]', $cc24605e9ae7f4f1$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $cc24605e9ae7f4f1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cc24605e9ae7f4f1$var$hasOwnProperty = $cc24605e9ae7f4f1$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $cc24605e9ae7f4f1$var$isEmpty(value) {
    if (value == null) return true;
    if ($bRRFB(value) && ($fZxmY(value) || typeof value == 'string' || typeof value.splice == 'function' || $cSA01(value) || $gQUlr(value) || $dI6Ko(value))) return !value.length;
    var tag = $1WABR(value);
    if (tag == $cc24605e9ae7f4f1$var$mapTag || tag == $cc24605e9ae7f4f1$var$setTag) return !value.size;
    if ($erbrP(value)) return !$eHPLt(value).length;
    for(var key in value){
        if ($cc24605e9ae7f4f1$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $cc24605e9ae7f4f1$var$isEmpty;

});

parcelRegister("jYxBx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $g58eM = parcelRequire("g58eM");

const $e8adb0147cc02fce$export$ca1b33377afa620 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getArtifact: null
});
function $e8adb0147cc02fce$export$56da85ac9d40dbcd({ children: children, product: product, config: config, fallbackArtifacts: fallbackArtifacts }) {
    const flightDeckClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return new (0, $g58eM.default)(product, {
            handlers: {
                captureException: config === null || config === void 0 ? void 0 : config.captureException
            },
            expiryMS: config === null || config === void 0 ? void 0 : config.artifactExpiryMS
        }, fallbackArtifacts);
    }, [
        product,
        config === null || config === void 0 ? void 0 : config.captureException,
        fallbackArtifacts
    ]);
    const getArtifact = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(async (name, dimensions)=>{
        return flightDeckClient.fetchConfigFromFlightDeck({
            name: name,
            dimensions: dimensions
        });
    }, [
        flightDeckClient
    ]);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            getArtifact: getArtifact
        }), [
        getArtifact
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e8adb0147cc02fce$export$ca1b33377afa620.Provider, {
        value: providerValue
    }, children);
}
const $e8adb0147cc02fce$export$73c96350a5e69ec = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($e8adb0147cc02fce$export$ca1b33377afa620);
function $e8adb0147cc02fce$export$3b241cde208d2c5e(key, dimensions) {
    const [artifact, setArtifact] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const { getArtifact: getArtifact } = $e8adb0147cc02fce$export$73c96350a5e69ec();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!getArtifact) throw new Error("Flight Deck Context not provided");
        getArtifact(key, dimensions).then((resp)=>setArtifact(resp))// we don't need to do anything with the error as it is already instrumented in the flightDeckClient
        .catch();
    }, [
        dimensions,
        key,
        getArtifact,
        setArtifact
    ]);
    return artifact;
}
module.exports["FlightDeckProvider"] = $e8adb0147cc02fce$export$56da85ac9d40dbcd;
module.exports["useFlightDeckContext"] = $e8adb0147cc02fce$export$73c96350a5e69ec;
module.exports["useFlightDeckArtifact"] = $e8adb0147cc02fce$export$3b241cde208d2c5e;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("69PnT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2228fa01b7e8b5ee470ffc60df47923d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47bb7135644f74cd$var$_react = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("42omo")));

var $47bb7135644f74cd$var$_baseNew = $47bb7135644f74cd$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $47bb7135644f74cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47bb7135644f74cd$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $47bb7135644f74cd$var$_react.default.createElement($47bb7135644f74cd$var$_baseNew.default, Object.assign({
        name: "ArrowUpRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$47bb7135644f74cd$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $47bb7135644f74cd$var$_default = module.exports.default = $47bb7135644f74cd$var$ArrowUpRightIcon;

});

parcelRegister("1R3zJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e6d73fa950add8a3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afa74181baaa67be5e1a2274a7254425>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $fP78j = parcelRequire("fP78j");

function $e6d73fa950add8a3$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("4LKV2", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $657d69142c9bac8b$export$75a72dd48f48bd1e = ()=>{
    // Moving from <Icon> to <svg> since this icon will be replaced soon
    // and because of the complexity of scaling each path in the SVG.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "22",
        viewBox: "0 0 32 22",
        // TODO: Update the attribute below so it is translated.
        // eslint-disable-next-line no-restricted-syntax
        "aria-label": "Card",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "path-1-inside-1_4424_408291",
        fill: "var(--ds-surface-raised, #FFFFFF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 11H24V21C24 21.5523 23.5523 22 23 22H9C8.44772 22 8 21.5523 8 21V11Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 11H24V21C24 21.5523 23.5523 22 23 22H9C8.44772 22 8 21.5523 8 21V11Z",
        fill: "var(--ds-surface-raised, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 11H24H8ZM25 21C25 22.1046 24.1046 23 23 23H9C7.89543 23 7 22.1046 7 21H9H23H25ZM9 23C7.89543 23 7 22.1046 7 21V11H9V21V23ZM25 11V21C25 22.1046 24.1046 23 23 23V21V11H25Z",
        fill: "var(--ds-background-neutral-hovered, #0B120E24)",
        mask: "url(#path-1-inside-1_4424_408291)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "11",
        y: "13",
        width: "10",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-neutral-hovered, #0B120E24)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "11",
        y: "16",
        width: "10",
        height: "2",
        rx: "1",
        fill: "var(--ds-background-neutral-hovered, #0B120E24)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_4424_408291)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "8",
        width: "16",
        height: "11",
        fill: "var(--ds-background-neutral-hovered, #0B120E24)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.56641 9.66749L13.2958 5.53027L17.0252 9.66749H9.56641Z",
        fill: "var(--ds-background-accent-blue-bolder, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.5586 9.66747L17.0239 3.60449L22.4891 9.66747H11.5586Z",
        fill: "var(--ds-icon-information, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        opacity: "0.37"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18.9894 7.11779C17.2437 6.25471 15.5864 6.72991 13.31 6.17401C11.7498 5.79302 9.81297 4.90515 8 2.75V10.9403H21.5292C21.3154 9.51503 20.6897 7.95836 18.9894 7.11779Z",
        fill: "url(#paint0_linear_4424_408291)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.3333 4.85151C12.0697 4.85151 12.6667 4.22717 12.6667 3.457C12.6667 2.68684 12.0697 2.0625 11.3333 2.0625C10.597 2.0625 10 2.68684 10 3.457C10 4.22717 10.597 4.85151 11.3333 4.85151Z",
        fill: "var(--ds-background-accent-orange-subtle, #FCA700)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "26",
        y: "19",
        width: "16",
        height: "11",
        transform: "rotate(-90 26 19)",
        fill: "var(--ds-background-neutral-hovered, #0B120E24)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "6",
        y: "3",
        width: "16",
        height: "11",
        transform: "rotate(90 6 3)",
        fill: "var(--ds-background-neutral-hovered, #0B120E24)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_4424_408291",
        x1: "21.6237",
        y1: "2.12675",
        x2: "6.03556",
        y2: "2.12675",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "var(--ds-border, #0B120E24)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.1252",
        stopColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        stopOpacity: "0.8589"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.5465",
        stopColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        stopOpacity: "0.4017"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.8366",
        stopColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        stopOpacity: "0.1128"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.9703",
        stopColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
        stopOpacity: "0.01"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_4424_408291"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8 1C8 0.447715 8.44772 0 9 0H23C23.5523 0 24 0.447715 24 1V11H8V1Z",
        fill: "var(--ds-background-neutral-hovered, #0B120E24)"
    }))));
};
module.exports["CardsExtensionIcon"] = $657d69142c9bac8b$export$75a72dd48f48bd1e;

});

parcelRegister("hjUk0", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $inPa6 = parcelRequire("inPa6");


var $eyWa4 = parcelRequire("eyWa4");


var $4A7Gn = parcelRequire("4A7Gn");

var $0DTaW = parcelRequire("0DTaW");

var $d2kvf = parcelRequire("d2kvf");


var $8eOJy = parcelRequire("8eOJy");


var $9kLHx = parcelRequire("9kLHx");

const $2557fa1f3f1be3a7$var$tabsListStyles = null;
const $2557fa1f3f1be3a7$export$1f2189c52356e986 = ({ source: source, tabSections: tabSections, onTabClick: onTabClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleTabClick = (0, $42omo.useCallback)((index)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'tab',
                actionSubjectId: 'configPanelNavigationPills',
                source: source,
                attributes: {
                    selectedValue: tabSections[index].value
                }
            }
        }).fire();
        onTabClick?.(tabSections[index]);
    }, [
        createAnalyticsEvent,
        tabSections,
        source,
        onTabClick
    ]);
    const configPanelRef = (0, $42omo.useRef)(null); // Focus the first tab when the config panel opens
    (0, $42omo.useEffect)(()=>{
        if (configPanelRef.current) {
            const firstTab = configPanelRef.current.querySelector('[role="tab"]');
            if (firstTab) firstTab.focus();
        }
    }, []);
    return /*#__PURE__*/ $42omo.createElement((0, $4A7Gn.default), {
        id: `${source}-config-panel-tabs`,
        onChange: handleTabClick
    }, /*#__PURE__*/ $42omo.createElement("div", {
        ref: configPanelRef,
        className: (0, $gMc0m.default)([
            "_n3tdv47k _1e8o1b66 _k88nn7od _1rxjn7od _1d96n7od _v229n7od"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $0DTaW.default), null, tabSections.map((tab, index)=>{
        return /*#__PURE__*/ $42omo.createElement((0, $9kLHx.PillTab), {
            key: index,
            label: tab.label
        });
    }))), tabSections.map((tab, index)=>{
        return /*#__PURE__*/ $42omo.createElement((0, $d2kvf.default), {
            key: index
        }, /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
            grow: "fill",
            testId: "tab-panel-content"
        }, tab.tabContent.map((section)=>section.defaultIsExpanded !== undefined && section.title ? /*#__PURE__*/ $42omo.createElement((0, $8eOJy.CollapsibleItem), {
                key: section.sectionId,
                title: section.title,
                section: section.sectionId,
                defaultIsExpanded: section?.defaultIsExpanded,
                source: source
            }, section.component) : /*#__PURE__*/ $42omo.createElement((0, $42omo.Fragment), {
                key: section.sectionId
            }, section.component))));
    }));
};
module.exports["ConfigPanelGrouping"] = $2557fa1f3f1be3a7$export$1f2189c52356e986;

});

parcelRegister("8eOJy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $bUlM5 = parcelRequire("bUlM5");

var $2W0qg = parcelRequire("2W0qg");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");

const $8c98457c9c23568d$var$pressableStyles = (0, $ecnYn.xcss)({
    background: 'none',
    height: 'space.300',
    paddingInline: 'space.100',
    paddingBlock: 'space.200'
});
const $8c98457c9c23568d$var$wrapperStyles = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $8c98457c9c23568d$var$expandedContainerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.200',
    paddingInline: 'space.100'
});
const $8c98457c9c23568d$export$1df80d75edaa7a50 = ({ title: title, defaultIsExpanded: defaultIsExpanded, section: section, children: children, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(defaultIsExpanded ?? false);
    const handleSectionClickAnalytics = (0, $42omo.useCallback)((newState, section)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'collapsible',
                actionSubjectId: 'configPanelSectionCollapsible',
                source: source,
                attributes: {
                    section: section,
                    action: newState ? 'expanded' : 'collapsed'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const handleClick = ()=>{
        handleSectionClickAnalytics(!isExpanded, section);
        setIsExpanded(!isExpanded);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100",
        xcss: $8c98457c9c23568d$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: handleClick,
        xcss: $8c98457c9c23568d$var$pressableStyles,
        testId: "collapsible-item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium",
        weight: "semibold"
    }, title), isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
        label: "",
        color: "var(--ds-icon, #292A2E)",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        color: "var(--ds-icon, #292A2E)",
        size: "small"
    }))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100",
        xcss: $8c98457c9c23568d$var$expandedContainerStyles
    }, children));
};
module.exports["CollapsibleItem"] = $8c98457c9c23568d$export$1df80d75edaa7a50;

});

parcelRegister("9kLHx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $bDrnk = parcelRequire("bDrnk");

const $85e70ef54f4ca0cf$var$baseStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    background: "var(--ds-background-neutral, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} solid transparent`,
    borderRadius: 'radius.full',
    gap: 'space.100',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingInline: 'space.150'
});
const $85e70ef54f4ca0cf$var$selectedStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    background: "var(--ds-background-selected, #E9F2FE)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`,
    borderRadius: 'radius.full',
    color: 'color.text.selected',
    gap: 'space.100',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingInline: 'space.150'
});
const $85e70ef54f4ca0cf$export$78d15021d44428c = ({ label: label })=>{
    const tabAttributes = (0, $bDrnk.default)();
    const isTabSelected = tabAttributes['aria-selected'];
    const { 'aria-controls': _ariaControls, ...tabAttributesWithoutControls } = tabAttributes;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isTabSelected ? $85e70ef54f4ca0cf$var$selectedStyles : $85e70ef54f4ca0cf$var$baseStyles,
        ...tabAttributesWithoutControls,
        role: "tab"
    }, label);
};
module.exports["PillTab"] = $85e70ef54f4ca0cf$export$78d15021d44428c;

});

parcelRegister("7Ux0V", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fQWPs = parcelRequire("fQWPs");

const $a249d56289792314$export$740dd80d7ba80184 = (backgroundColor, isReadableForegroundColor, foregroundColor, updateForegroundColor, defaultParameters)=>{
    (0, $42omo.useEffect)(()=>{
        // No need to do autotransition when background color is same as default BackgroundColor, e.g. theme color
        if (!isReadableForegroundColor(foregroundColor) && backgroundColor !== defaultParameters?.backgroundColor) {
            const textColorToken = (0, $fQWPs.extractToken)(foregroundColor);
            if (textColorToken === (0, $fQWPs.extractToken)("var(--ds-text, #292A2E)")) updateForegroundColor("var(--ds-text-inverse, #FFFFFF)");
            else if (textColorToken === (0, $fQWPs.extractToken)("var(--ds-text-inverse, #FFFFFF)")) updateForegroundColor("var(--ds-text, #292A2E)");
            else if (foregroundColor === defaultParameters?.textColor) {
                if (isReadableForegroundColor("var(--ds-text, #292A2E)")) updateForegroundColor("var(--ds-text, #292A2E)");
                else updateForegroundColor("var(--ds-text-inverse, #FFFFFF)");
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        backgroundColor
    ]);
};
module.exports["useAutoTransitioningColors"] = $a249d56289792314$export$740dd80d7ba80184;

});

parcelRegister("e1Ppq", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $16a18baf3b2f13e0$var$CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/confluence-header-image-generation';
const $16a18baf3b2f13e0$export$7624fc593a548cde = ({ contentId: contentId, eventCallbacks: eventCallbacks })=>{
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    const [data, setData] = (0, $42omo.useState)(null);
    const [aiHeaderImageStatus, setAIHeaderImageStatus] = (0, $42omo.useState)('NOT_LOADING');
    const showAcceptanceFlowRef = (0, $42omo.useRef)(false);
    const abortControllerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (error) {
            setAIHeaderImageStatus('ERROR');
            return;
        }
        if (loading) {
            if (showAcceptanceFlowRef.current) setAIHeaderImageStatus('LOADING_WITH_ACCEPTANCE_FLOW');
            else setAIHeaderImageStatus('LOADING');
        } else setAIHeaderImageStatus('NOT_LOADING');
    }, [
        loading,
        error
    ]);
    const generateImage = (0, $42omo.useCallback)(async ({ adfContent: adfContent, aspectRatio: aspectRatio, showAcceptanceFlow: showAcceptanceFlow = false, useRawPrompt: useRawPrompt = false, theme: theme })=>{
        const eventParams = {
            contentId: contentId,
            useRawPrompt: useRawPrompt || false,
            ...theme && {
                theme: theme
            },
            ...aspectRatio && {
                aspectRatio: aspectRatio
            }
        };
        // Notify start
        eventCallbacks?.onGenerateStart?.(eventParams);
        // Abort potential ongoing request
        abortControllerRef.current?.abort();
        abortControllerRef.current = new AbortController();
        showAcceptanceFlowRef.current = showAcceptanceFlow;
        setError(null);
        setData(null);
        if (!loading) setLoading(true);
        try {
            const request = {
                ai_feature_input: {
                    adfContent: adfContent,
                    contentId: contentId,
                    useRawPrompt: useRawPrompt,
                    ...theme !== undefined && {
                        theme: theme
                    },
                    ...aspectRatio !== undefined && {
                        aspectRatio: aspectRatio
                    }
                }
            };
            const response = await fetch($16a18baf3b2f13e0$var$CONVO_AI_URL, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json;charset=UTF-8',
                    'X-Experience-Id': 'confluence-ai-first-creation',
                    'X-Product': 'confluence'
                },
                body: JSON.stringify(request),
                signal: abortControllerRef.current.signal
            });
            if (!response.ok) throw new Error(`Error fetching AI-generated cover image, status code: ${response.status}`);
            const responseData = await response.json();
            const content = responseData?.ai_feature_output;
            if (!content) {
                const noContentError = new Error('No content received from API');
                setError(noContentError.message);
                eventCallbacks?.onGenerateError?.({
                    ...eventParams,
                    error: noContentError
                });
                return;
            }
            // Check if the response contains an error in the body (API can return 200 OK with error in body)
            if (content.error) {
                const errorMessage = content.error.error_message || content.error.error_reason || 'AI image generation failed';
                const apiError = new Error(errorMessage);
                setError(errorMessage);
                eventCallbacks?.onGenerateError?.({
                    ...eventParams,
                    error: apiError
                });
                return;
            }
            const responseContent = content;
            setData(responseContent);
            // Notify success
            eventCallbacks?.onGenerateSuccess?.(eventParams);
            return responseContent.mediaFileId;
        } catch (err) {
            const isErrorType = err instanceof Error;
            // Don't set error for aborted requests
            if (isErrorType && err.name === 'AbortError') {
                eventCallbacks?.onGenerateAbort?.(eventParams);
                return;
            }
            const errorMessage = isErrorType ? err.message : 'Unknown error occurred';
            const error = isErrorType ? err : new Error(errorMessage);
            setError(errorMessage);
            eventCallbacks?.onGenerateError?.({
                ...eventParams,
                error: error
            });
        } finally{
            setLoading(false);
        }
    }, [
        contentId,
        loading,
        eventCallbacks
    ]);
    // Begin loading experience but don't generate yet
    const fakeGenerateImage = (0, $42omo.useCallback)(()=>{
        showAcceptanceFlowRef.current = false;
        setError(null);
        setData(null);
        setLoading(true);
    }, []);
    return {
        generateImage: generateImage,
        fakeGenerateImage: fakeGenerateImage,
        loading: loading,
        error: error,
        data: data,
        aiHeaderImageStatus: aiHeaderImageStatus,
        aiHeaderImageFileId: data?.mediaFileId,
        setAIHeaderImageStatus: setAIHeaderImageStatus
    };
};
module.exports["useAIGeneratedCoverImage"] = $16a18baf3b2f13e0$export$7624fc593a548cde;

});

parcelRegister("9URG7", function(module, exports) {
const $7498a8c5d7a74725$export$12cc65019788286c = {
    photorealistic: 'photorealistic',
    abstract: 'abstract',
    watercolors: 'watercolors',
    graphic_design: 'graphic_design',
    landscape: 'landscape'
};
module.exports["IMAGE_GENERATION_THEMES"] = $7498a8c5d7a74725$export$12cc65019788286c;

});

parcelRegister("dOOm2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fqANv = parcelRequire("fqANv");

var $5k6WH = parcelRequire("5k6WH");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64c374ed616824e$var$GradientPropertyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _kqswh2mm _c71l1kw7",
            __cmplp.className
        ])
    });
});
const $f64c374ed616824e$var$outerContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $fqANv.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f64c374ed616824e$var$animationStyles = (0, $ecnYn.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f64c374ed616824e$var$baseGlowStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f64c374ed616824e$var$defaultBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.large'
});
const $f64c374ed616824e$var$modalBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small'
});
const $f64c374ed616824e$var$innerContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f64c374ed616824e$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $5k6WH.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f64c374ed616824e$var$outerContainerStyles,
        $f64c374ed616824e$var$animationStyles
    ] : [
        $f64c374ed616824e$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f64c374ed616824e$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f64c374ed616824e$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f64c374ed616824e$var$modalBorderRadiusStyles : $f64c374ed616824e$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f64c374ed616824e$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props
    }, shouldRotate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles,
            ...hideGlow ? [] : glowStyles
        ],
        testId: "loading-glow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.025",
        xcss: [
            $f64c374ed616824e$var$innerContainerStyles,
            borderRadiusStyles,
            customInnerContainerStyles
        ]
    }, children)));
};
module.exports["AIBorder"] = $f64c374ed616824e$export$6ed1e39f4dbe0bbf;

});

parcelRegister("fqANv", function(module, exports) {
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $7ebe4f6aaaab63a6$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
module.exports["reduceMotionAsPerUserPreference"] = $7ebe4f6aaaab63a6$export$f0f789643ba5a83c;

});

parcelRegister("9M4aB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0eee459540e5ec28215a3b80df0172>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $71dbd4ce92c1377b$var$_react = $71dbd4ce92c1377b$var$_interopRequireDefault((parcelRequire("42omo")));

var $71dbd4ce92c1377b$var$_baseNew = $71dbd4ce92c1377b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $71dbd4ce92c1377b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $71dbd4ce92c1377b$var$ShareIcon = (props)=>/*#__PURE__*/ $71dbd4ce92c1377b$var$_react.default.createElement($71dbd4ce92c1377b$var$_baseNew.default, Object.assign({
        name: "ShareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$71dbd4ce92c1377b$var$ShareIcon.displayName = 'ShareIcon';
var $71dbd4ce92c1377b$var$_default = module.exports.default = $71dbd4ce92c1377b$var$ShareIcon;

});

parcelRegister("1662I", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ccb09ee82030ea4$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $e0mB4 = parcelRequire("e0mB4");


var $6b5eb = parcelRequire("6b5eb");


var $b5utg = parcelRequire("b5utg");

var $0ccb09ee82030ea4$var$MILLISECONDS_IN_WEEK = 604800000;
function $0ccb09ee82030ea4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var diff = (0, $e0mB4.default)(date).getTime() - (0, $6b5eb.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $0ccb09ee82030ea4$var$MILLISECONDS_IN_WEEK) + 1;
}

});

parcelRegister("e0mB4", function(module, exports) {
$parcel$export(module.exports, "default", () => $a322980fc7bdc1cb$export$2e2bcd8739ae039);

var $ghphD = parcelRequire("ghphD");


var $b5utg = parcelRequire("b5utg");

function $a322980fc7bdc1cb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $ghphD.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});

parcelRegister("6b5eb", function(module, exports) {
$parcel$export(module.exports, "default", () => $47f7d34a77e920df$export$2e2bcd8739ae039);

var $3Klnc = parcelRequire("3Klnc");


var $e0mB4 = parcelRequire("e0mB4");


var $b5utg = parcelRequire("b5utg");

function $47f7d34a77e920df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var year = (0, $3Klnc.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $e0mB4.default)(fourthOfJanuary);
    return date;
}

});

parcelRegister("3Klnc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ba63f43afaf9481$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $e0mB4 = parcelRequire("e0mB4");


var $b5utg = parcelRequire("b5utg");

function $2ba63f43afaf9481$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $e0mB4.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $e0mB4.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});

parcelRegister("aPCur", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $3gadb = parcelRequire("3gadb");


var $4K9rx = parcelRequire("4K9rx");


var $4VyWY = parcelRequire("4VyWY");


var $4gY0b = parcelRequire("4gY0b");

const $4c5fe77c591c2edb$var$styles = {
    borderOptionContainer: "_1rjcv77o _18zr1b66 _bfhk1j9a _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1tcg",
    border: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1",
    selected: "_1h6d1w55 _bfhk15s3"
};
const $4c5fe77c591c2edb$export$b2197740663fbf1 = ({ cornerStyleValue: cornerStyleValue, updateCornerStyle: updateCornerStyle, roundCornerValue: roundCornerValue, squareCornerValue: squareCornerValue })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleCornerOptionClick = (cornerOption)=>updateCornerStyle(cornerOption);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $4gY0b.messages).cornerStyle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, [
        {
            cornerOption: roundCornerValue,
            IconComponent: (0, $4K9rx.RoundCornerIcon),
            label: (0, $4gY0b.messages).roundCornerStyleLabel
        },
        {
            cornerOption: squareCornerValue,
            IconComponent: (0, $4VyWY.SharpCornerIcon),
            label: (0, $4gY0b.messages).squareCornerStyleLabel
        }
    ].map(({ cornerOption: cornerOption, IconComponent: IconComponent, label: label })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            key: cornerOption,
            content: formatMessage(label)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: (0, $1Whri.cx)($4c5fe77c591c2edb$var$styles.borderOptionContainer, $4c5fe77c591c2edb$var$styles.border, cornerStyleValue === cornerOption && $4c5fe77c591c2edb$var$styles.selected),
            onClick: ()=>handleCornerOptionClick(cornerOption),
            testId: `${cornerOption}${cornerStyleValue === cornerOption ? '--selected' : ''}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconComponent, {
            color: cornerStyleValue === cornerOption ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
            label: formatMessage(label)
        })));
    })));
};
module.exports["CornerStyleConfig"] = $4c5fe77c591c2edb$export$b2197740663fbf1;

});

parcelRegister("4gY0b", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $772b9aa8dda76a10$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    cornerStyle: {
        id: "company-hub.company-hub-common.links-menu.corner.style",
        defaultMessage: "Corner style"
    },
    roundCornerStyleLabel: {
        id: "company-hub.company-hub-common.links-menu.corner.style-round",
        defaultMessage: "Round"
    },
    squareCornerStyleLabel: {
        id: "company-hub.company-hub-common.links-menu.corner.style-square",
        defaultMessage: "Square"
    }
});
module.exports["messages"] = $772b9aa8dda76a10$export$defe85febe8b728c;

});


//# sourceMappingURL=cards-extension.fae43d5b.js.map
